module.exports = __webpack_public_path__ + "img/Fullscreen.2470afe1.svg";